<template>
  <v-menu
    tabindex="0"
    :close-on-content-click="false"
    v-model="menuFlag"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <TextField
      v-if="controlType == 'textfield'"
      slot="activator"
      :id="id"
      :disabled="disabled"
      v-bind="textFieldConfig"
      :value="textInputValue"
      @valuechanged="onValueChange"
      :placeholder="this.placeholder"
      @validated="onValidation"
      @startEditing="(e) => (menuFlag = e)"
    ></TextField>

    <input
      v-if="controlType == 'input'"
      slot="activator"
      class="dbox-table--textfield"
      type="text"
      :name="id"
      :id="id"
      :disabled="disabled"
      :value="textInputValue"
      v-on:blur="(e) => onTextInputBlur(e)"
    />

    <v-date-picker
      :value="textInputValue"
      @input="onDatePickerInput"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { isValid, format } from "date-fns";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: () => "Date",
    },
    value: {
      required: false,
    },
    required: {
      default: () => false,
    },
    format: {
      type: String,
      default: () => `YYYY-MM-DD`,
    },
    emitImmediate: {
      type: Boolean,
      default: () => false,
    },
    showImmediate: {
      type: Boolean,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    controlType: {
      type: String,
      default: () => "textfield",
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (to, from) {
        // console.log(to);
        try {
          if (isValid(new Date(to))) {
            if (this.showImmediate) {
              this.textInputValue = format(to, this.format);
            }

            if (this.emitImmediate) {
              this.emitValue(this.textInputValue);
            }
          } else {
            this.textInputValue = "";
          }
        } catch (e) {
          // console.log(e, 'Invalid Date input');
          // if (this.required) {
          //   this.textInputValue = format(new Date(), this.format);
          //   this.emitValue(this.textInputValue);
          // }
        }
      },
    },
  },
  data: function () {
    return {
      textInputValue: "",

      menuFlag: null,

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      validationResult: {},
    };
  },
  methods: {
    onValueChange: function (id, value) {
      // console.log('onValueChange');
      this.emitValue(value);
    },
    emitValue: function (value) {
      // console.log("Log: emitValue", value);
      this.$emit("input", value);
      this.$emit("valuechanged", this.id, value);
    },
    onDatePickerInput: function (value) {
      // console.log('onDatePickerInput');
      this.menuFlag = false;
      this.emitValue(value);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextInputBlur: function (event) {
      // console.log('onTextInputBlur');
      const value = event.target.value;

      if (value !== this.textInputValue) {
        this.emitValue();
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
// Global Date Picker Style
.picker--date {
  .picker__title.primary {
    display: none;
  }
}
</style>
